module.exports = __webpack_public_path__ + "img/C07TechUlfhednarChampion_ua.02170ec6.webp";